"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cNewDiscussionSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../../hooks");
exports.cNewDiscussionSchema = zod_1.z.strictObject({
    event: zod_1.z.literal(hooks_1.HookName.newDiscussion),
    action: zod_1.z.literal(hooks_1.HookName.newDiscussion),
    meta: zod_1.z.optional(zod_1.z.strictObject({
        requester: zod_1.z.number()
    })),
    qaUrl: zod_1.z.optional(zod_1.z.string()),
    /** ID of block where this user communication was created */
    targetId: zod_1.z.string().uuid(),
    entityId: zod_1.z.optional(zod_1.z.string().uuid()),
    /** ID of user communication just created */
    postId: zod_1.z.number(),
    senderProfile: zod_1.z.optional(zod_1.z.number()),
    message: zod_1.z.string(),
    linkToComment: zod_1.z.optional(zod_1.z.string()),
    location: zod_1.z.optional(zod_1.z.object({
        moduleSlug: zod_1.z.optional(zod_1.z.string()),
        pageSlug: zod_1.z.optional(zod_1.z.string()),
        name: zod_1.z.optional(zod_1.z.string()),
        page: zod_1.z.optional(zod_1.z.number())
    })),
    allowPersonalEmailReplies: zod_1.z.optional(zod_1.z.boolean()),
    scope: zod_1.z.optional(zod_1.z.string())
});
